import TextOverflowTooltip from './TextOverflowTooltip';

export default TextOverflowTooltip;
